import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { RejectType, StateService, Transition, TransitionService, UrlService } from '@uirouter/core';

import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { LocalStorage } from 'services/storage/local';
import { LoggerService } from './http/logger';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class XmErrorHandler implements ErrorHandler {
    private state: StateService;
    private route: UrlService;
    private config: IXMOptions;
    private localStorage: LocalStorage;
    private transition: TransitionService;
    private transitionErrorFrom: string;
    private transitionErrorTo: string;
    private logger: LoggerService;

    constructor(state: StateService, route: UrlService, localStorage: LocalStorage, @Inject(CONFIG_TOKEN) config: IXMOptions, transition: TransitionService, logger: LoggerService) {
        Object.assign(this, { state, route, localStorage, config, transition, logger });

        this.transition.onStart({ from: 'error' }, () => {
            this.transitionErrorFrom = undefined;
            this.transitionErrorTo = undefined;
        });

        this.transition.onError({}, (trans: Transition) => {
            if (trans.error().type === RejectType.ERROR) {
                this.transitionErrorFrom = trans.from().name || 'app_load';
                this.transitionErrorTo = trans.to().name;
            }
        });
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
    /* eslint-disable no-console */
    public handleError(error: any): void {
        if (error.stack && (error.stack.includes('assets.adobedtm.com') || error.stack.includes('satelliteLib') || error.stack.search(/giggy.*.js/) >= 0)) {
            return;
        }

        const stateName: string = this.state.current.name;

        // to prevent an infinite loop
        if (this.route.url().includes('error')) {
            return;
        }

            if (stateName === 'shop.device' || stateName === 'shop.accessory') {
                this.state.go('product-downtime');

                return;
            }

            // Redirect to websheet error page for websheet activation issues
            if (this.route.url().includes('watches/activate') || this.route.url().includes('esim/activate')) {
                this.state.go('watch.activate.error');

                return;
            }

            // Redirect to activation error page for activation issues
            if (this.route.url().includes('activate')) {
                this.state.go('activation-error');

                return;
            }

            if (!this.localStorage.hasKey('xm-error')) {
                this.localStorage.set('xm-error', JSON.stringify(error.stack || error));
            }

            const data: HttpErrorResponse | string = {
                ...error,
                message: error.message ? JSON.parse(JSON.stringify(error.message)): ''
            };
            this.logger.scriptError(data);
            console.error(error);

            const reason: string = this.transitionErrorFrom ? `${this.transitionErrorFrom}-${this.transitionErrorTo}` : stateName;
            const url: string = `${window.location.protocol}//${window.location.host}${this.config.BASE_URL}error?reason=${reason}`;
            window.location.href = url;
        }
    }
